import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const STEPS = [
  { key: "select", label: "Select jobs" },
  { key: "details", label: "Billing details" },
  { key: "review", label: "Review & send" },
]

const GenerateInvoiceStepper = ({ currentStep }) => {
  const currentIndex = STEPS.findIndex((s) => s.key === currentStep)

  return (
    <div className="flex items-center gap-2">
      {STEPS.map((step, index) => {
        const isComplete = index < currentIndex
        const isActive = index === currentIndex

        return (
          <React.Fragment key={step.key}>
            <div className="flex select-none items-center gap-2">
              <span
                className={classNames(
                  "flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold",
                  {
                    "bg-teal-600 text-white": isComplete,
                    "bg-blue-600 text-white": isActive,
                    "bg-gray-200 text-gray-500": !isComplete && !isActive,
                  }
                )}
              >
                {isComplete ? <i className="fa-solid fa-check" /> : index + 1}
              </span>
              <span
                className={classNames("text-sm", {
                  "font-semibold text-gray-900": isActive,
                  "text-teal-600": isComplete,
                  "text-gray-500": !isComplete && !isActive,
                })}
              >
                {step.label}
              </span>
            </div>
            {index < STEPS.length - 1 && (
              <div
                className={classNames("h-px flex-1", {
                  "bg-teal-600": isComplete,
                  "bg-gray-200": !isComplete,
                })}
              />
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

GenerateInvoiceStepper.propTypes = {
  currentStep: PropTypes.oneOf(["select", "details", "review"]).isRequired,
}

export default GenerateInvoiceStepper
